import { Button, Flex, Text } from "@paguelofacil/pf-components";
import { FormattedMessage } from "react-intl";

import { language, languageDefault } from "../services/utils/Language";

import "../assets/scss/containers.scss";

export const ConnectAccount = ({ handleConnectAccount }) => {
    return (
        <Flex gap="1.25rem" direction="column" align="start">
            <ul className="container-list-connect">
                <li>
                    <FormattedMessage
                        id={language.description_connect_zinli_one}
                        defaultMessage={languageDefault.description_connect_zinli_one}
                    />
                </li>
                <li>
                    <FormattedMessage
                        id={language.description_connect_zinli_two}
                        defaultMessage={languageDefault.description_connect_zinli_two}
                    />
                </li>
                <li>
                    <FormattedMessage
                        id={language.description_connect_zinli_three}
                        defaultMessage={languageDefault.description_connect_zinli_three}
                    />
                </li>
            </ul>
            <Button className="button-primary-cf" fullWidth handleClick={handleConnectAccount} size="md">
                <FormattedMessage id={language.connect} defaultMessage={languageDefault.connect} />
            </Button>

            <Text variant="caption" weight="regular" style={{ maxWidth: "46rem" }}>
                <FormattedMessage
                    id={language.first_term_conditions}
                    defaultMessage={languageDefault.first_term_conditions}
                />
                &nbsp;
                <a href="http://www.paguelofacil.com/terminos-y-condiciones/" target="_blank" rel="noreferrer">
                    <FormattedMessage id={language.term_conditions} defaultMessage={languageDefault.term_conditions} />
                </a>
                &nbsp;
                <FormattedMessage
                    id={language.second_term_conditions}
                    defaultMessage={languageDefault.second_term_conditions}
                />
            </Text>
        </Flex>
    );
};
